// extracted by mini-css-extract-plugin
export default {"tableElement":"Col_tableElement__-mdBN","delete":"Col_delete__B8u7T","tableHeaders":"Col_tableHeaders__Hml9H","red":"Col_red__MfxOk"};